/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import { makeStyles } from 'src/makeStyles';
import { colors, fontSize, newLineHeight, boxShadows, maskTextStyles } from '../../constants/styleConstants';
import route from '../../constants/routes';
import StaticGoogleMapView from '../StaticGoogleMapView';
import NextLink from '../NextLink';
import { getRouteWithSlug } from '../../utils/common';

const useStyles = makeStyles()(theme => ({
  venueCard: {
    minHeight: '75px',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '8px',
    boxShadow: boxShadows.sideCard,
    border: `solid 1px ${colors.border.grey}`,
    marginBottom: 20,
  },
  locationIcon: {
    color: colors.blueChip,
    marginRight: 18,
  },
  map: {
    justifyContent: 'flex-end',
    height: '100%',
  },
  locationText: {
    fontFamily: 'Roboto',
    fontSize: fontSize.smallTitle,
    lineHeight: newLineHeight,
    [theme.breakpoints.up('sm')]: {
      fontSize: fontSize.medium,
    },
  },
  locationBlock: {
    maxWidth: '80%',
    width: '80%',
    display: 'flex',
    padding: '20px 20px 20px 15px',
    alignItems: 'center',
  },
  mapContainer: {
    width: '20%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  maskText: {
    textShadow: '0 0 5px rgb(45,46,49,0.4)',
    ...maskTextStyles,
    cursor: 'pointer',
  },
  link:{
    wordBreak: 'break-all'
  }
}));

const VenueCard = ({ className, venuesList, title, onVenueClick }) => {
  const { classes, cx } = useStyles();

  if (venuesList.length === 0) {
    return null;
  }
  const maskText = '################## ############ #########';

  return (
    <>
      {title && title}
      {venuesList.map((venue, index) => {
        return (
          <div key={`${venue.name}-${index}`} className={cx(classes.venueCard, className)}>
            <div className={classes.locationBlock}>
              <LocationOnIcon className={classes.locationIcon} />
              {venue.id === -1 ? (
                <span onClick={() => onVenueClick()} className={cx(classes.locationText, classes.maskText)}>
                  {maskText}
                </span>
              ) : (
                <NextLink
                  className={classes.link}
                  href={`${route.VENUES}/[country]/[id]/[[...action]]`}
                  as={getRouteWithSlug(`${route.VENUES}/${get(venue, 'country.slug')}`, venue)}
                >
                  <span className={classes.locationText}>
                    {venue.name} {venue.address && <span>, {venue.address}</span>}
                  </span>
                </NextLink>
              )}
            </div>
            {venue.lat && venue.lon && (
              <div className={classes.mapContainer}>
                <a href={`https://www.google.com/maps/search/?api=1&query=${venue.lat},${venue.lon}`} target="_blank">
                  <StaticGoogleMapView
                    className={classes.map}
                    zoom="10"
                    size="82x75"
                    location={`${venue.lat},${venue.lon}`}
                  />
                </a>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

VenueCard.propTypes = {
  className: PropTypes.string,
  venuesList: PropTypes.array,
  title: PropTypes.node,
};

export default VenueCard;
